import React from "react";
import "./ConfirmationModal.scss";
import Popup from "../../atoms/Popup/Popup";
import Button from "../../atoms/Button/Button";

interface ModalProps {
  show: boolean;
  onConfirmation: (action: boolean) => void;
  onClose: () => void;
}

const ConfirmationModal: React.FC<ModalProps> = ({
  show,
  onConfirmation,
  onClose,
}) => {
  const handleConfirm = (action: boolean) => {
    onConfirmation(action);
  };
  return (
    <Popup
      show={show}
      onClose={onClose}
      headerText="Confirmation"
      closeOnOverlayClick
    >
      <div className="confirmation-modal-container">
        <div className="confirmation-modal-content">
          Are you sure you want to take this action?
          <br />
          This action can not be Undone.
        </div>
        {/* Dismiss first, confirm last - the same order as every other dialog,
            and it keeps the irreversible action away from the reflex click. */}
        <div className="popup-footer">
          <Button variant="outlined" onClick={() => handleConfirm(false)}>
            No
          </Button>
          <Button onClick={() => handleConfirm(true)}>Yes</Button>
        </div>
      </div>
    </Popup>
    // <div>
    //     {show && (
    //         <div className="modal">
    //             <div className="close-btn" onClick={onClose}><span>X</span></div>
    //             <div className="modal-content">
    //                 <div>
    //                     <p>Are you sure you want to take this action?</p>
    //                     <p>This action can not be Undone</p>
    //                 </div>
    //                 <div className="button-container">
    //                     <button className="modal-btn" onClick={() => handleConfirm(true)}>Yes</button>
    //                     <button className="modal-btn" onClick={() => handleConfirm(false)}>No</button>
    //                 </div>
    //             </div>
    //         </div>
    //     )}
    // </div>
  );
};

export default ConfirmationModal;
